export default __webpack_public_path__ + "static/media/cyzzy.471c2189.png";